import type { ReactNode } from "react";
import { Search } from "lucide-react";

interface ToolbarSearch {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name of the search field. */
  label: string;
}

interface ToolbarProps {
  search?: ToolbarSearch;
  /** `FilterMenu`s and similar controls. */
  filters?: ReactNode;
  /** Right-aligned mono count, e.g. "128 messages". */
  count?: ReactNode;
}

/** Table toolbar: search field + filter slots + right-aligned mono count. */
export function Toolbar({ search, filters, count }: ToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-ds-line px-3 py-2.5 font-ds">
      {search && (
        <label className="flex h-8 w-full items-center gap-1.5 rounded-lg border border-ds-line2 bg-ds-panel px-2.5 text-ds-ink3 focus-within:ring-2 focus-within:ring-ds-accent sm:w-[260px]">
          <Search className="h-3.5 w-3.5 flex-none" aria-hidden="true" />
          <input
            type="search"
            aria-label={search.label}
            value={search.value}
            placeholder={search.placeholder}
            onChange={(event) => search.onChange(event.target.value)}
            className="h-full w-full bg-transparent text-[13px] text-ds-ink outline-none placeholder:text-ds-ink3"
          />
        </label>
      )}
      {filters}
      <span className="flex-1" />
      {count !== undefined && <span className="font-ds-mono text-[12.5px] text-ds-ink3">{count}</span>}
    </div>
  );
}
